<template>
  <div class="background-view">
    &nbsp;
    <div class="item-name-view">
      <el-row>
        <el-col :span="12">
          <div class="item-name">{{info[0].title}}</div>
          <div class="item-value-text">{{info[0].value}}</div>
        </el-col>
        <el-col :span="12">
          <div class="item-name">{{info[1].title}}</div>
          <div class="item-value-text">{{info[1].value}}</div>
        </el-col>
      </el-row>
    </div>
    <div class="divider">&nbsp;</div>
    <div>
      <div class="item-name-view">
        <el-row>
          <el-col :span="12">
            <div class="item-name">{{info[2].title}}</div>
            <div class="item-value-text">{{info[2].value}}</div>
          </el-col>
          <el-col :span="12">
            <div class="item-name">{{info[3].title}}</div>
            <div class="item-value-text">{{info[3].value === undefined ? '无' : info[3].value}}</div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="divider">&nbsp;</div>
    <div>
      <div class="item-name-view">
        <el-row>
          <el-col :span="12">
            <div class="item-name">{{info[4].title}}</div>
            <div class="item-value-text">{{info[4].value === undefined ? '无' : info[4].value}}</div>
          </el-col>
          <el-col :span="12">
            <div class="item-name">{{info[5].title}}</div>
            <div class="item-value-text">{{info[5].value === undefined ? '无' : '¥' + info[5].value}}</div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: Array
  }
};
</script>

<style>
.item-name-view {
  margin-left: 16px;
  margin-top: 16px;
}
.background-view {
  background: #ffffff;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.03);
  border-radius: 12px;
  width: 359px;
  height: 226px;
  margin-left: 8px;
}
.item-name {
  font-family: PingFangSC-Medium;
  font-size: 13px;
  color: #ff943d;
  letter-spacing: 0;
  text-align: left;
  line-height: 16px;
}
.item-value-text {
  margin-top: 5px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
  line-height: 20px;
  text-align: left;
}
.divider {
  background: #d8d8d8;
  margin-left: 16px;
  margin-right: 16px;
  margin-top: 16px;
  height: 1px;
}
</style>